import { render } from "./CustomNodeContent.vue?vue&type=template&id=1a5dfb8d"
import script from "./CustomNodeContent.vue?vue&type=script&lang=js"
export * from "./CustomNodeContent.vue?vue&type=script&lang=js"

import "./CustomNodeContent.vue?vue&type=style&index=0&id=1a5dfb8d&lang=css"
script.render = render

export default script